import React from "react";
import Seo from "../components/Seo";
import Layout from "../layouts/sample";
import {Intro} from "../components/build/Intro";
import {Discover} from "../components/build/Discover";
import {Solutions} from "../components/build/Solutions";
import {Ecosystem} from "../components/develop/Ecosystem";
import {Subscribe} from "../components/global/Subscribe";
import {graphql} from "gatsby";


const BuildPage = (props) => {

  const acf = props.data.page.template.buildPageACF || {};

  const acfDevelop = props.data.develop.template.developPageACF || {};
  const translations = props?.data?.page?.translations || {}
  const stats = props?.data?.page?.template?.statsACF.numbers || [];

  return (
    <Layout translations={translations}>
      <Intro data={acf.intro} stats={stats}/>
      <Discover data={acf.discover} data2={acf.discover2}/>
      <Solutions data={acf.bitcoin}/>
      <Ecosystem color={'orange'} data={acfDevelop.ecosystem}/>
      <Subscribe/>
    </Layout>
  );
};

export default BuildPage;

export const pageQuery = graphql`
  query ($lng: String!, $id: Int!) {
    locales: allLocale(
      filter: { language: { eq: $lng } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    page : wpPage(language: {slug: {eq: $lng}}, databaseId: { eq: $id }) {
      seo {
        metaDesc
        opengraphDescription
        opengraphTitle
        title
      }
      translations {
        slug
      }
      title
      template {
        ... on WpTemplate_Build {
          statsACF {
            numbers {
              label
              title
              value
              source
              image {
                localFile {
                  publicURL
                }
                publicUrl
                width
                height
            }
            }
          }
          buildPageACF {
             bitcoin {
              items {
                button {
                  target
                  title
                  url
                }
                fieldGroupName
                color
                classes
                text
                title
              }
              number
              subtitle
              suptext1
              suptext2
              text
              titlePart1
              titlePart2
              titlePart3
            }
            discover {
              cardText
              cardTitle
              fieldGroupName
              number
              suptitle
              title
              text
            }
            discover2 {
              items {
                text
                title
              }
              link {
                target
                title
                url
              }
              number
              suptitle
              text
              title
            }
            intro {
              items {
                fieldGroupName
                qty
                title
                label
              }
              link {
                target
                url
                title
              }
              number
              suptext1
              text
              titlePart1
              titlePart2
              titlePart3
              titlePart4
            }
          }
        }
      }
    },
    develop : wpPage(language: {slug: {eq: $lng}}, template: {templateName: {eq: "Develop"}}) {
      title
      template {
        ... on WpTemplate_Develop {
          developPageACF {
            ecosystem {
              link {
                target
                title
                url
              }
              number
              subtitle
              text
              title
            }
          }
        }
      }
    }
  }
`;

export const Head = (props) => {
  const seo = props.data.page?.seo || {}
  return <Seo title={seo?.title} description={seo?.metaDesc} />;
}
